// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './config.js'

/*引入下面三行,使用elementUI框架*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
/*引入下面三行,使用elementUI框架*/
// import ElementUI from 'element-ui';
// import './styles/element-variables.scss'

// 引入全局css
import './assets/iconfont/iconfont.css';
import './styles/index.scss' // global css

import axios from './http';  //此处问http文件的路径
// 将API方法绑定到全局
Vue.prototype.$axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
var vueObj = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

export default vueObj



// WEBPACK FOOTER //
// ./src/main.js